import { getDistance } from "./geo/geo/get-distance.js";
const sortByDistance = (reference, items) => items.map((item) => [item, getDistance(reference, item)]).sort((a, b) => a[1] - b[1]);
export {
  sortByDistance
};
//# sourceMappingURL=sort-by-distance.js.map
